<template>
  <div class="h-100">
    <!-- 帮助 -->
    <div
      id="helpModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="helpModelLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="width:600px">
          <div class="modal-header bg-info text-white">
            <h5 id="helpModelLabel" class="modal-title">
              <i class="far fa-question-circle mr-1"></i> {{ t("helpTitle") }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>{{ t("helpIntro1") }}</p>
            <p v-html="t('helpIntro2')"></p>
            <p>{{ t("helpWhatToDo") }}</p>
            <ul>
              <li>{{ t("helpStep1") }}</li>
              <li>{{ t("helpStep2") }}</li>
              <li>{{ t("helpStep3") }}</li>
              <li>{{ t("helpStep4") }}</li>
              <li>{{ t("helpStep5") }}</li>
              <li>{{ t("helpStep6") }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 设置 -->
    <div 
      id="configModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="configModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header text-info">
            <h5 id="configModalLabel" class="modal-title">
              <i class="fas fa-sliders-h mr-1"></i> {{ t('settings') }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="关闭">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- 开关设置 -->
            <div class="form-group row custom-control custom-switch ml-1">
              <input id="cameraLightSwitch" v-model="cameraLight" type="checkbox" class="custom-control-input">
              <label class="custom-control-label" for="cameraLightSwitch">{{ t('cameraLight') }}</label>
            </div>
            <div class="form-group row custom-control custom-switch ml-1">
              <input id="doubleSideSwitch" v-model="doubleSide" type="checkbox" class="custom-control-input">
              <label class="custom-control-label" for="doubleSideSwitch">{{ t('doubleSide') }}</label>
            </div>
            <div class="form-group row custom-control custom-switch ml-1">
              <input id="performanceModeSwitch" v-model="performanceMode" type="checkbox" class="custom-control-input">
              <label class="custom-control-label" for="performanceModeSwitch">{{ t('performanceMode') }}</label>
            </div>

            <!-- 颜色选择器 -->
            <ColorEditor v-model="background_color" :name="t('backgroundColor')" />
            <ColorEditor v-model="selectionColor" :name="t('selectionColor')" />

            <!-- 折叠面板 -->
            <div id="accordionExample" class="accordion">
              <div class="card">
                <div id="headingOne" class="card-header">
                  <h4 class="mb-0">
                    <button class="btn btn-link btn-block text-left collapsed" type="button"
                      data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      {{ t('objectColors') }}
                    </button>
                  </h4>
                </div>
                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                  <div class="card-body">
                    <ColorEditor
                      v-for="(color, type) in object_colors"
                      :key="type"
                      v-model="object_colors[type]"
                      :name="type"
                    />
                  </div>
                </div>
              </div>

              <div class="card">
                <div id="headingTwo" class="card-header">
                  <h4 class="mb-0">
                    <button class="btn btn-link btn-block text-left collapsed" type="button"
                      data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      {{ t('surfaceColors') }}
                    </button>
                  </h4>
                </div>
                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                  <div class="card-body">
                    <ColorEditor
                      v-for="(color, type) in surface_colors"
                      :key="type"
                      v-model="surface_colors[type]"
                      :name="type"
                    />
                  </div>
                </div>
              </div>

              <div class="card">
                <div id="headingThree" class="card-header">
                  <h5 class="mb-0">
                    <button class="btn btn-link btn-block text-left collapsed" type="button"
                      data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                      {{ t('conditionalFormatting') }}
                    </button>
                  </h5>
                </div>
                <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                  <div class="card-body">
                    <div class="form-group row custom-control custom-switch ml-1">
                      <input id="conditionalFormattingSwitch" v-model="conditionalFormatting" type="checkbox" class="custom-control-input">
                      <label class="custom-control-label" for="conditionalFormattingSwitch">{{ t('show') }}</label>
                    </div>
                    <div class="form-group">
                      <label for="conditionalAttributeSelect">{{ t('attribute') }}</label>
                      <select id="conditionalAttributeSelect" class="form-control"
                        @change="conditionalAttribute = $event.target.value">
                        <option value=""></option>
                        <option v-for="attribute in conditionalAttributes" :key="attribute">
                          {{ attribute }}
                        </option>
                      </select>
                    </div>
                    <ColorEditor
                      v-for="(color, type) in attributeColors"
                      :key="type"
                      v-model="attributeColors[type]"
                      :name="type"
                    />
                  </div>
                </div>
              </div>

              <div class="card">
                <div id="headingAppearance" class="card-header">
                  <h5 class="mb-0">
                    <button class="btn btn-link btn-block text-left collapsed" type="button"
                      data-toggle="collapse" data-target="#collapseAppearance" aria-expanded="false" aria-controls="collapseAppearance">
                      {{ t('appearance') }}
                    </button>
                  </h5>
                </div>
                <div id="collapseAppearance" class="collapse" aria-labelledby="headingAppearance" data-parent="#accordionExample">
                  <div class="card-body">
                    <div class="form-group">
                      <label for="materialThemeSelect">{{ t('materialTheme') }}</label>
                      <select id="materialThemeSelect" class="form-control"
                        @change="activeMaterialTheme = $event.target.value">
                        <option value="undefined"></option>
                        <option v-for="theme of materialThemes" :key="theme">{{ theme }}</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label for="textureThemeSelect">{{ t('textureTheme') }}</label>
                      <select id="textureThemeSelect" class="form-control"
                        @change="activeTextureTheme = $event.target.value">
                        <option value="undefined"></option>
                        <option v-for="theme of textureThemes" :key="theme">{{ theme }}</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label for="textureThemeSelect">{{ t('textures') }} ({{ resolvedTextures }} / {{ totalTextures }})</label>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fas fa-image mr-1"></i> {{ t('textures') }}</span>
                        </div>
                        <div class="custom-file">
                          <input id="inputGroupFile01" ref="textureFile" type="file" class="custom-file-input"
                            multiple="multiple" @change="uploadTexture">
                          <label class="custom-file-label" for="inputGroupFile01">{{ t('chooseFile') }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="performanceModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="performanceModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header bg-warning text-white">
            <h5
              id="performanceModalLabel"
              class="modal-title"
            >
              <i class="fas fa-exclamation-triangle mr-1"></i> {{ t("performanceModalTitle") }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-header">
            <h5 class="modal-title"></h5>
          </div>
          <div class="modal-body">
            <span v-html="t('performanceModalBody').replace(/\n/g, '<br>')"></span>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="performanceMode = false"
            >
            {{ t("performanceModalConfirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 导航栏 -->
    <nav class="navbar navbar-dark" :class="[ file_loaded ? 'bg-dark' : 'bg-white' ]">
      <a class="navbar-brand d-flex align-items-center"  :class="[ file_loaded ? 'text-white' : 'text-dark' ]" href="#">
        <img v-if="!file_loaded" :src="require('url:../public/trans_bg.png')" class="logo-w mr-2">
        <img v-else :src="require('url:../public/white_on_black.png')" class="logo-b mr-2">
        <span :class="{ 'text-big' : !file_loaded }">CityJSONViewer</span>
      </a>
      <div class="d-flex justify-content-end align-items-center col-auto p-0">
        <div v-show="loading" class="spinner-border text-warning mr-2" role="status">
          <span class="sr-only">{{ t("loading") }}</span>
        </div>
        <button type="button" class="btn btn-outline-info mr-1" data-toggle="modal" data-target="#configModal">
          <i class="fas fa-sliders-h mr-1"></i> {{ t("settings") }}
        </button>
        <button type="button" class="btn" :class="[ file_loaded ? 'btn-outline-light' : 'btn-outline-dark' ]"
          data-toggle="modal" data-target="#helpModal">
          <i class="far fa-question-circle mr-1"></i> {{ t("helpTitle") }}
        </button>
        <!-- 新增语言切换按钮 -->
        <button type="button" class="btn btn-outline-primary ml-2" @click="toggleLang">
          🌐 {{ lang === 'zh' ? '英文' : 'Chinese' }}
        </button>
        <button type="button" class="btn ml-2" 
                :class="[ file_loaded ? 'btn-outline-light' : 'btn-outline-dark' ]" 
                @click="showTexture">
          🖼 {{ t("showtex")}}
        </button>
        <!-- 图片弹窗 -->
        <div v-if="showTextureDialog" class="texture-modal-mask">
          <div class="texture-modal">
            <!-- 关闭按钮 -->
            <button class="modal-close" @click="closeTextureDialog">×</button>
            
            <!-- 图片列表标题 -->
            <h3 class="modal-title">Texture 图片列表</h3>
            
            <!-- 图片容器 -->
            <div class="texture-list">
              <div v-for="(img, index) in textureImages" :key="index" class="texture-item">
                <img 
                  :src="`/texture/${img}`"
                  :alt="`texture-${index}`" 
                  class="texture-img"
                  @error="handleImgError(index)"
                >
                <p class="texture-name">{{ img }}</p>
              </div>
              
              <!-- 无图片时显示 -->
              <div v-if="textureImages.length === 0" class="no-texture">
                未找到图片
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <!-- 加载模型后的主页面 -->
    <div
      v-if="file_loaded"
      id="main_content"
    >
      <div class="container-fluid h-100">
        <div class="row h-100">
          <!-- 左侧页面 -->
          <div class="d-sm-none d-lg-block col-lg-1 bg-dark p-0">
            <ninja-sidebar
              v-model="active_sidebar"
              :with_versions="has_versions"
              :lang="lang"
            ></ninja-sidebar>
          </div>
          <!-- 中间页面 -->
          <div class="col-3 p-0 h-100">
            <div
              v-show="active_sidebar == 'objects'"
              class="h-100"
            >
              <div class="h-100 d-flex flex-column">
                <div class="p-3 shadow-sm">
                  <h5>
                    {{ t("obj_text") }}
                    <span
                      v-if="active_version != null"
                      class="badge badge-primary mr-1"
                    >
                      {{ t("version_lab") }} {{ active_version | truncate(7) }}
                    </span>
                    <span class="badge badge-secondary">
                      {{ (activeCityModel && activeCityModel.CityObjects) ? Object.keys(activeCityModel.CityObjects).length : 0 }} {{t("count_label")}}
                    </span>
                  </h5>
                  <input
                    v-model="search_term"
                    type="search"
                    class="form-control col mb-2 shadow-sm"
                    :placeholder="t('search_lab')"
                  >
                  <div
                    v-show="file_loaded"
                    class="d-flex justify-content-end col-auto p-0"
                  >
                    <button
                      class="btn btn-primary col-auto"
                      @click="downloadModel()"
                    >
                      <i class="fas fa-download mr-1"></i> {{ t("download_btn") }}
                    </button>
                    <button
                      class="btn btn-danger col-auto ml-2"
                      @click="reset()"
                    >
                      <i class="fas fa-times mr-1"></i> {{ t("close_btn") }}
                    </button>
                  </div>
                </div>
                <CityObjectsTree
                  v-if="! performanceMode || showTreeInPerformanceMode"
                  :key="active_version"
                  :citymodel="activeCityModel"
                  :cityobjects="firstLevelObjects"
                  :selected_objid="selected_objid"
                  :matches="matches"
                  :hidden-objects="hiddenObjects"
                  @object_clicked="move_to_object( [ $event, - 1, - 1 ] )"
                  @toggle_visibility="toggleObjectVisibility"
                ></CityObjectsTree>
                <div
                  v-if="performanceMode && !showTreeInPerformanceMode"
                  class="p-2"
                >
                  <div
                    class="alert alert-warning"
                    role="alert"
                  >
                    <h4 class="alert-heading">
                      {{ t("pmode_title") }}
                    </h4>

                    <span v-html="t('pmode_description').replace(/\n/g, '<br>')"></span>
                    
                    <hr>
                    {{ t("pmode_warning") }}
                  </div>
                  <button
                    type="button"
                    class="btn btn-success mr-2"
                    @click="showTreeInPerformanceMode = true"
                  >
                    <i class="fas fa-sitemap mr-1"></i> {{ t("enable_tree_in_pmode") || "启用对象树" }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-warning"
                    data-toggle="modal"
                    data-target="#performanceModal"
                  >
                  {{ t("disable_pmode") }}
                  </button>
                </div>
                <!-- 性能模式下显示对象树时的提示 -->
                <div
                  v-if="performanceMode && showTreeInPerformanceMode"
                  class="px-3 py-2 bg-warning text-dark small"
                >
                  <i class="fas fa-exclamation-triangle mr-1"></i>
                  {{ t("pmode_tree_warning") || "性能模式下运行，如遇卡顿可" }}
                  <a href="#" class="text-dark" @click.prevent="showTreeInPerformanceMode = false">
                    <strong>{{ t("hide_tree") || "隐藏对象树" }}</strong>
                  </a>
                </div>
              </div>
            </div>
            <div v-show="active_sidebar == 'versions'" class="h-100">
              <div class="h-100 d-flex flex-column">
                <div class="p-3 shadow-sm">
                  <h5>{{ t("version_nav") }}</h5>
                  <ul class="list-group">
                    <li
                      v-for="vid in versions_list"
                      :key="vid"
                      class="list-group-item d-flex justify-content-between align-items-center"
                      :class="{ 'active': active_version === vid }"
                      @click="switchVersion(vid)"
                      style="cursor:pointer;"
                    >
                      {{ vid }}
                      <span v-if="active_version === vid" class="badge badge-light">{{ t("current_lab") }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
          <!-- 右侧页面 -->
          <div class="col-8 p-0 h-100">
            <!-- 右上角控制按钮组 -->
            <div
              class="col-auto m-2"
              style="position: absolute; z-index: 1; right: 0; top: 0; display: flex; gap: 10px;"
            >
              <!-- 视角切换下拉菜单 -->
              <div class="dropdown">
                <button
                  class="btn btn-sm btn-primary dropdown-toggle"
                  type="button"
                  id="cameraViewDropdown"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="fas fa-video mr-1"></i> {{ t('cameraView') }}
                </button>
                <div class="dropdown-menu" aria-labelledby="cameraViewDropdown">
                  <a class="dropdown-item" href="#" @click.prevent="changeCameraView('front')">{{ t('viewFront') }}</a>
                  <a class="dropdown-item" href="#" @click.prevent="changeCameraView('back')">{{ t('viewBack') }}</a>
                  <a class="dropdown-item" href="#" @click.prevent="changeCameraView('left')">{{ t('viewLeft') }}</a>
                  <a class="dropdown-item" href="#" @click.prevent="changeCameraView('right')">{{ t('viewRight') }}</a>
                  <a class="dropdown-item" href="#" @click.prevent="changeCameraView('top')">{{ t('viewTop') }}</a>
                  <a class="dropdown-item" href="#" @click.prevent="changeCameraView('bottom')">{{ t('viewBottom') }}</a>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" href="#" @click.prevent="resetCamera">
                    <i class="fas fa-undo mr-1"></i>{{ t('resetCamera') }}
                  </a>
                </div>
              </div>
              <!-- 性能模式按钮 -->
              <button
                type="button"
                class="btn btn-sm"
                :class="performanceMode ? 'btn-warning' : 'btn-info'"
                @click="togglePerformanceMode"
                :title="performanceMode ? t('disablePerformanceMode') : t('enablePerformanceMode')"
              >
                <i class="fas" :class="performanceMode ? 'fa-tachometer-alt' : 'fa-bolt'"></i>
                {{ performanceMode ? t('performanceModeOn') : t('performanceModeOff') }}
              </button>
              <!-- 旋转按钮 -->
              <button
                type="button"
                class="btn btn-sm"
                :class="isRotating ? 'btn-danger' : 'btn-primary'"
                @click="toggleRotation"
                :title="isRotating ? t('stopRotation') : t('startRotation')"
              >
                <i class="fas fa-sync-alt" :class="{ 'fa-spin': isRotating }"></i>
                {{ isRotating ? t('rotating') : t('rotate') }}
              </button>
              <!-- 全屏按钮 -->
              <button
                class="btn btn-sm btn-success"
                @click="toggleFullscreen"
              >
                <i :class="isFullscreen ? 'fas fa-compress' : 'fas fa-expand'" class="mr-1"></i>
                {{ isFullscreen ? t('exitFullscreen') : t('fullscreen') }}
              </button>
            </div>
            <div
              class="col-auto m-2"
              style="position: absolute; z-index: 1"
            >
              <CityObjectCard
                v-if="existsSelected"
                :citymodel="activeCityModel"
                :cityobject="activeCityModel.CityObjects[selected_objid]"
                :cityobject_id="selected_objid"
                :geometry-id="selectedGeometryId"
                :boundary-id="selectedBoundaryId"
                :expanded="0"
                :editable="true"
                @input="activeCityModel.CityObjects[selected_objid] = $event"
                @close="selected_objid = null"
              ></CityObjectCard>
            </div>
            <ThreeJsViewer
              ref="viewer"
              :citymodel="activeCityModel"
              :selected-objid="selected_objid"
              :selected-geom-idx="selectedGeometryId"
              :selected-boundary-idx="selectedBoundaryId"
              :object-colors="object_colors"
              :surface-colors="surface_colors"
              :background-color="background_color"
              :selection-color="selectionColor"
              :show-semantics="showSemantics"
              :active-lod="activeLoD"
              :camera-spotlight="cameraLight"
              :highlight-selected-surface="highlightSurface"
              :conditional-formatting="conditionalFormatting"
              :conditional-attribute="conditionalAttribute"
              :attribute-colors="attributeColors"
              :active-material-theme="activeMaterialTheme"
              :texture-manager="textureManager"
              :active-texture-theme="activeTextureTheme"
              :double-side="doubleSide"
              :ambient-occlusion="ambientOcclusion"
              :file-type="file_type"
              :hidden-objects="hiddenObjects"
              @object_clicked="move_to_object($event)"
              @rendering="loading = $event"
              @loadCompleted="onLoadComplete()"
              @chunkLoaded="availableLoDs = $refs.viewer.getLods()"
              @objectColorsChanged="object_colors = $event"
              @surfaceColorsChanged="surface_colors = $event"
              @attributeColorsChanged="attributeColors = $event"
            ></ThreeJsViewer>
            <div
              style="position: absolute; z-index: 1; bottom: 0px; left: 0px"
            >
              <div class="custom-control custom-switch ml-1">
                <input
                  id="surfaceSwitch"
                  v-model="highlightSurface"
                  type="checkbox"
                  class="custom-control-input"
                >
                <label
                  class="custom-control-label"
                  for="surfaceSwitch"
                >{{ t('op_1') }}</label>
              </div>
              <div class="custom-control custom-switch ml-1">
                <input
                  id="semanticsSwitch"
                  v-model="showSemantics"
                  type="checkbox"
                  class="custom-control-input"
                >
                <label
                  class="custom-control-label"
                  for="semanticsSwitch"
                >{{ t('op_2') }}</label>
              </div>
              <div class="custom-control custom-switch ml-1">
                <input
                  id="ambientOcclussionSwitch"
                  v-model="ambientOcclusion"
                  type="checkbox"
                  class="custom-control-input"
                >
                <label
                  class="custom-control-label"
                  for="ambientOcclussionSwitch"
                >{{ t('op_3') }}</label>
              </div>
              <div
                class="btn-group ml-1 mb-1 bg-white"
                role="group"
                aria-label="Basic example"
              >
                <button
                  type="button"
                  :class="['btn', activeLoD == - 1 ? 'btn-primary' : 'btn-outline-primary']"
                  @click="activeLoD = - 1"
                >
                  All
                </button>
                <button
                  v-for="( lod, idx ) in availableLoDs"
                  :key="lod"
                  type="button"
                  :class="['btn', activeLoD == idx ? 'btn-primary' : 'btn-outline-primary']"
                  @click="activeLoD = idx"
                >
                  LoD{{ lod }}
                </button>
              </div>
            </div>
            <div
              class="card"
              style="position: absolute; z-index: 1; bottom: 0px; right: 0px"
            >
              <div class="m-1 px-2">
                <a
                  href="https://cityjson.org"
                  target="_blank"
                ><img
                  src="https://www.cityjson.org/assets/images/cityjson_logo.svg"
                  alt=""
                ></a>
              </div>
              <div class="m-1 px-2">
                <a
                  class="card-link"
                  href="https://github.com/cityjson/ninja"
                  target="_blank"
                ><i class="fab fa-github"></i> CJV v0.0.1</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 访问页面的默认主页 -->
    <div v-else>
      <div class="container" style="width:75%; max-width: 680px">
        <div class="row">
          <main class="col-12 py-md-3 pl-md-5">
            <h2>{{ t("fileUploadTitle") }}</h2>
            <p>{{ t("fileUploadDesc") }}</p>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="fas fa-upload mr-1"></i> {{ t("upload") }}</span>
              </div>
              <div class="custom-file">
                <input id="inputGroupFile01" ref="cityJSONFile" type="file" class="custom-file-input" accept=".json,.jsonl" @change="selectedFile">
                <label class="custom-file-label" for="inputGroupFile01">{{ t("chooseFile") }}</label>
              </div>
            </div>
            <!-- 新增示例按钮 -->
            <div class="flex gap-4">
              <button class="btn btn-primary" @click="loadDemoModel">
                {{ t('demo_1') }}
              </button>
              <button class="btn btn-primary" @click="loadDemoScene">
                {{ t('demo_2') }}
              </button>
            </div>
            <div v-show="error_message" class="alert alert-danger" role="alert">
              {{ error_message }}
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ColorEditor from './components/ColorEditor.vue';
import NinjaSidebar from './components/NinjaSidebar.vue';
import { AttributeEvaluator, TextureManager } from 'cityjson-threejs-loader';
import CityObjectCard from './lib-components/CityObjectCard.vue';
import CityObjectsTree from './lib-components/CityObjectsTree.vue';
import ThreeJsViewer from './lib-components/ThreeJsViewer.vue';
import { CityJSONSeqUtils } from './helpers/cjseq';
import $ from 'jquery';
import _ from 'lodash';
import cubeDemo from "../public/cube2.json";
import sceneDemo from "../public/Railway.json";
import translations from "./i18n/translations.js";

export default {
	name: 'App',
	components: {
		ColorEditor,
		NinjaSidebar,
		ThreeJsViewer,
		CityObjectsTree,
		CityObjectCard
	},
	data: function () {

		return {
      lang: 'zh', // 默认中文
      translations,
			file_loaded: false, //false true
			search_term: "",
			isFullscreen: false,
			citymodel: {},
			selected_objid: null,
			selectedGeometryId: - 1,
			selectedBoundaryId: - 1,
			loading: false,
			error_message: null,
			file_type: "json",
			active_sidebar: 'objects', // objects/versions
			has_versions: false,
			active_branch: 'master',
			active_version: null, //null, v1
      versions_list: [],      // 存放所有版本的 ID
			object_colors: {
				"Building": 0x7497df,
				"BuildingPart": 0x7497df,
				"BuildingInstallation": 0x7497df,
				"Bridge": 0x999999,
				"BridgePart": 0x999999,
				"BridgeInstallation": 0x999999,
				"BridgeConstructionElement": 0x999999,
				"CityObjectGroup": 0xffffb3,
				"CityFurniture": 0xcc0000,
				"GenericCityObject": 0xcc0000,
				"LandUse": 0xffffb3,
				"PlantCover": 0x39ac39,
				"Railway": 0x000000,
				"Road": 0x999999,
				"SolitaryVegetationObject": 0x39ac39,
				"TINRelief": 0xffdb99,
				"TransportSquare": 0x999999,
				"Tunnel": 0x999999,
				"TunnelPart": 0x999999,
				"TunnelInstallation": 0x999999,
				"WaterBody": 0x4da6ff
			},
			surface_colors: {
				"GroundSurface": 0x999999,
				"WallSurface": 0xffffff,
				"RoofSurface": 0xff0000,
				"TrafficArea": 0x6e6e6e,
				"AuxiliaryTrafficArea": 0x2c8200,
				"Window": 0x0059ff,
				"Door": 0x640000
			},
			background_color: 0xd9eefc,
			selectionColor: 0xffc107,
			showSemantics: true,
			highlightSurface: false,
			availableLoDs: [],
			activeLoD: - 1,
			cameraLight: false,
			doubleSide: true,
			ambientOcclusion: false,
			performanceMode: false,
			conditionalFormatting: false,
			conditionalAttribute: '',
			attributeColors: {},
			materialThemes: [],
			activeMaterialTheme: 'undefined',
			textureManager: null,
			textureThemes: [],
			activeTextureTheme: 'undefined',
      showTextureDialog: false,  // 控制弹窗显示/隐藏
      textureImages: [],  // 存储图片文件名列表
      fileSize: 0,  // 存储文件大小（字节）
      isRotating: false,  // 控制自动旋转状态
      hiddenObjects: new Set(),  // 存储隐藏的对象ID集合
      showTreeInPerformanceMode: false  // 性能模式下是否显示对象树
		};

	},
	computed: {
    // 是否包含版本信息
		activeCityModel: function () {

			if ( this.active_version != null ) {
        console.log('当前版本', this.active_version);

				return this.extract_citymodel( this.active_version );

			} else {

				return this.citymodel;

			}

		},
    // 根据是否加载文件，返回不同的logo，似乎没有用到
		logoUrl: function () {

			if ( this.file_loaded ) {

				return "logoWhite.svg";

			}

			return "logoBlack.svg";

		},
    // 获取所有顶层对象（没有父对象的对象）
		// firstLevelObjects: function () {

		// 	return _.pickBy( this.activeCityModel.CityObjects, function ( cityobject ) {

		// 		return ! ( cityobject.parents && cityobject.parents.length > 0 );

		// 	} );

		// },
    firstLevelObjects: function () {
      return _.pickBy(this.activeCityModel.CityObjects, function(cityobject) {
          // 如果 parents 不存在或长度为0，视为顶级
          if (!cityobject.parents || cityobject.parents.length === 0) {
              return true;
          }

          // 如果有父级，但父级在 CityObjects 中不存在，也视为顶级（孤立子级）
          const parentExists = cityobject.parents.some(parentId =>
              parentId in this.activeCityModel.CityObjects
          );

          return !parentExists;
      }.bind(this)); // 注意 bind(this) 保证 this 指向
    },
    // 根据搜索词过滤对象
		filteredCityObjects: function () {

			var result = _.pickBy( this.activeCityModel.CityObjects, function ( value, key ) {

				var regex = RegExp( this.search_term, "i" );
				var obj_json = JSON.stringify( value );
				return regex.test( key ) | regex.test( obj_json );

			} );

			return result;

		},
		existsSelected: function () {

			return this.selected_objid != null;

		},
		conditionalAttributes: function () {

			if ( ! this.citymodel || ! this.citymodel.CityObjects ) {

				return [];

			}

			const attributes = new Set( Object.keys( this.citymodel.CityObjects ).map( objId => {

				const cityobject = this.citymodel.CityObjects[ objId ];

				if ( cityobject && cityobject.attributes && typeof cityobject.attributes === 'object' && cityobject.attributes !== null ) {

					return Object.keys( cityobject.attributes );

				}

				return [];

			} ).flat() );

			const atts = [ ...attributes ].filter( a => {

				const evaluator = new AttributeEvaluator( this.citymodel, a, false );

				return evaluator.getUniqueValues().length > 1 && evaluator.getUniqueValues().length < 20;

			} );

			return atts;

		},
		totalTextures: function () {

			if ( this.textureManager ) {

				return this.textureManager.totalTextures;

			}

			return 0;

		},
		resolvedTextures: function () {

			if ( this.textureManager ) {

				return this.textureManager.resolvedTextures;

			}

			return 0;

		}
	},
  watch: {
    // 监听性能模式变化，同步更新citymodel的冻结状态
    performanceMode(newVal) {
      if (this.citymodel) {
        if (newVal) {
          // 开启性能模式：冻结citymodel
          this.citymodel = Object.freeze(this.citymodel);
          console.log('性能模式已开启，citymodel已冻结');
        } else {
          // 关闭性能模式：解冻citymodel
          // 需要创建一个新的未冻结对象
          const unfrozenCitymodel = JSON.parse(JSON.stringify(this.citymodel));
          this.citymodel = unfrozenCitymodel;
          console.log('性能模式已关闭，citymodel已解冻');
        }
      }
    }
  },
  mounted() {
    //console.log('cubeDemo');
    //this.loadCityJSON(cubeDemo);
  },
	methods: {
    // 显示弹窗并加载图片列表
    showTexture() {
      this.showTextureDialog = true;
      this.textureImages = ['wood.jpg', 'brick.jpg','Trunk_MAT.jpeg','Branch_MAT.png'];// 
      //this.fetchTextureImages();  // 获取图片列表
    },
    
    // 关闭弹窗
    closeTextureDialog() {
      this.showTextureDialog = false;
    },
    
    // 获取public/texture下的图片列表（需后端接口支持）
    fetchTextureImages() {
      // 实际项目中通过后端接口获取图片文件名列表
      // 示例：假设后端接口为 /api/get-textures
      this.axios.get('/api/get-textures')
        .then(res => {
          if (res.data.success) {
            this.textureImages = res.data.images;  // 格式：['img1.png', 'img2.jpg']
          }
        })
        .catch(err => {
          console.error('获取图片列表失败：', err);
          // 若没有后端接口，可手动指定静态图片列表
          // this.textureImages = ['demo1.png', 'demo2.jpg']; // 静态列表示例
        });
    },
    
    // 处理图片加载失败
    handleImgError(index) {
      console.warn(`图片 ${this.textureImages[index]} 加载失败`);
    },
    // 切换性能模式
    togglePerformanceMode() {
      if (this.performanceMode) {
        // 关闭性能模式时显示确认弹窗
        $('#performanceModal').modal('show');
      } else {
        // 开启性能模式
        this.performanceMode = true;
      }
    },
    t(key) {
      return this.translations[this.lang][key] || key;
    },
    toggleLang() {
      this.lang = this.lang === 'zh' ? 'en' : 'zh';
    },
    loadDemoModel() {
      this.loadCityJSON(cubeDemo);
    },

    loadDemoScene() {
      this.loadCityJSON(sceneDemo);
    },
    // 调试代码
    loadCityJSON(cm) {

      if (!this.validateCityJSON(cm)) {
        console.error("cubeDemo 不是合法的 CityJSON");
        return;
      }

      // 性能模式判断：对象数 > 3000 或文件大小 > 100MB
      const objectCount = Object.keys(cm.CityObjects).length;
      const fileSizeMB = this.fileSize / (1024 * 1024);
      this.performanceMode = objectCount > 3000 || fileSizeMB > 100;
      this.citymodel = this.performanceMode ? Object.freeze(cm) : cm;

      // 处理版本信息
      if (cm.versioning && cm.versioning.versions) {
        this.has_versions = true;
        this.versions_list = Object.keys(cm.versioning.versions);

        if (this.versions_list.length > 0) {
          this.active_version = this.versions_list[0];
        }
      } else {
        this.has_versions = false;
        this.versions_list = [];
        this.active_version = null;
      }

      this.file_type = "json";
      this.file_loaded = true; // 显示主页面

      // 初始化材质和纹理信息
      this.materialThemes = this.getMaterialThemes(this.citymodel);
      this.textureThemes = this.getTextureThemes(this.citymodel);
      this.textureManager = new TextureManager(this.citymodel);

      console.log("Demo模型加载完成:", this.citymodel);
    },
		extract_citymodel( vid ) {
      console.log('extract_citymodel', vid);

			var object_dict = this.citymodel.versioning.versions[ vid ].objects;
			var original_objects = this.citymodel.CityObjects;

			var result = $.extend( {}, this.citymodel );

			result[ "CityObjects" ] = {};

			delete result[ "versioning" ];

			Object.keys( object_dict ).forEach( ( key ) => {

				result[ "CityObjects" ][ key ] = $.extend( {}, original_objects[ object_dict[ key ] ] );

			} );

			return result;

		},
    switchVersion(vid) {
      this.active_version = vid
      this.$nextTick(() => {
        this.$refs.viewer.loadCitymodel(this.activeCityModel)
      })
    },
    // 选择对象的函数 
		move_to_object( ids ) {

			if ( ids ) {

				// `ids` is in the form of [ objectId, geometryId, boudnaryId ]
				this.selected_objid = ids[ 0 ];
				this.selectedGeometryId = ids[ 1 ];
				this.selectedBoundaryId = ids[ 2 ];
        console.log('选中对象', this.selected_objid);

			} else {

				this.selected_objid = null;
				this.selectedGeometryId = - 1;
				this.selectedBoundaryId = - 1;

			}

		},
    // 关闭当前浏览的模型
		reset() {

			this.citymodel = {};
			this.search_term = "";
			this.file_loaded = false;
			this.file_type = "json";

		},
		matches( coid, cityobject ) {

			var regex = RegExp( this.search_term, "i" );
			var obj_json = JSON.stringify( cityobject );
			if ( cityobject.children && cityobject.children.length > 0 ) {

				return regex.test( coid ) || regex.test( obj_json ) || cityobject.children.some( obj_id => {

					return this.matches( obj_id, this.citymodel.CityObjects[ obj_id ] );

				} );

			} else {

				return regex.test( coid ) || regex.test( obj_json );

			}

		},
		// 切换对象的显示/隐藏状态
		toggleObjectVisibility( { objId, visible } ) {
			// 获取对象及其所有子对象的ID
			const allIds = this.getAllDescendantIds( objId );
			
			// 创建新的 Set 以触发响应式更新
			const newHiddenObjects = new Set( this.hiddenObjects );
			
			allIds.forEach( id => {
				if ( visible ) {
					newHiddenObjects.delete( id );
				} else {
					newHiddenObjects.add( id );
				}
			} );
			
			this.hiddenObjects = newHiddenObjects;
		},
		// 获取对象及其所有后代对象的ID
		getAllDescendantIds( objId ) {
			const result = [ objId ];
			const cityObject = this.activeCityModel.CityObjects[ objId ];
			
			if ( !cityObject ) return result;
			
			// 处理 children
			if ( cityObject.children && cityObject.children.length > 0 ) {
				cityObject.children.forEach( childId => {
					result.push( ...this.getAllDescendantIds( childId ) );
				} );
			}
			
			// 处理 CityObjectGroup 的 members
			if ( cityObject.type === 'CityObjectGroup' && cityObject.members ) {
				cityObject.members.forEach( memberId => {
					result.push( ...this.getAllDescendantIds( memberId ) );
				} );
			}
			
			return result;
		},
		// 检查对象是否被隐藏
		isObjectHidden( objId ) {
			return this.hiddenObjects.has( objId );
		},
    // 验证是否为CityJSON文件，直接检查根key的type字段
		validateCityJSON( cm ) {

			if ( cm.type !== "CityJSON" ) {

				this.error_message = "This is not a CityJSON file!";

				return false;

			}

			return true;

		},
		uploadTexture() {

			const files = this.$refs.textureFile.files;

			for ( const file in files ) {

				this.textureManager.setTextureFromFile( files[ file ] );

			}

		},
    // 选择文件后的处理函数，加载模型，赋给this.citymodel
		selectedFile() {

			this.loading = true;
			let cm;

			let file = this.$refs.cityJSONFile.files[ 0 ];
			if ( ! file ) {

				this.error_message = "No file selected!";
				this.loading = false;
				return;

			}
      
      // 记录文件大小
      this.fileSize = file.size;
      // 记录加载开始时间
      const startTime = performance.now();

			// Determine file type based on extension
			const fileName = file.name.toLowerCase();
			if ( fileName.endsWith( '.json' ) ) {

				this.file_type = "json";

			} else if ( fileName.endsWith( '.jsonl' ) ) {

				this.file_type = "jsonl";

			} else {

				this.error_message = "Please select a .json or .jsonl file!";
				this.loading = false;
				return;

			}

			let reader = new FileReader();
			reader.readAsText( file, "UTF-8" );
			reader.onload = async evt => {

				const fileContent = evt.target.result;

				if ( this.file_type === "jsonl" ) {

					// For CityJSONSeq files, validate the first line
					if ( CityJSONSeqUtils.validateCityJSONSeq( fileContent ) === false ) {

						this.error_message = 'Invalid CityJSONSeq file';
						this.loading = false;
						return;

					}

					const util = new CityJSONSeqUtils();
					cm = await util.toCityJSON( fileContent );

				} else {

					// For regular CityJSON files, parse and validate
					cm = JSON.parse( fileContent );

					if ( this.validateCityJSON( cm ) === false ) {

						this.loading = false;
						return;

					}

				}


				// 性能模式判断：对象数 > 3000 或文件大小 > 100MB
				const objectCount = Object.keys(cm.CityObjects).length;
				const fileSizeMB = this.fileSize / (1024 * 1024);
				this.performanceMode = objectCount > 3000 || fileSizeMB > 100;
				this.citymodel = this.performanceMode ? Object.freeze( cm ) : cm;
				this.has_versions = "versioning" in cm;

				this.file_loaded = true;
				this.loading = false;
        
        // 记录加载完成时间
        const endTime = performance.now();
        
        // 计算并输出加载耗时
        const loadTime = ((endTime - startTime) / 1000).toFixed(2);
        console.log(`模型加载完成，耗时: ${loadTime} 秒`);


        if (this.citymodel.versioning && this.citymodel.versioning.versions) {
          this.has_versions = true
          this.versions_list = Object.keys(this.citymodel.versioning.versions)

          // 可选：默认显示第一个版本
          if (this.versions_list.length > 0) {
            this.active_version = this.versions_list[0]
          }
        } else {
          this.has_versions = false
          this.versions_list = []
          this.active_version = null
        }

			};

		},
    // 实际的下载函数
		download( filename, text ) {

			var element = document.createElement( 'a' );
			element.setAttribute( 'href', 'data:application/json;charset=utf-8,' + encodeURIComponent( text ) );
			element.setAttribute( 'download', filename );

			element.style.display = 'none';
			document.body.appendChild( element );

			element.click();

			document.body.removeChild( element );

		},
    // 下载模型
		downloadModel() {

			var text = JSON.stringify( this.citymodel );

			this.download( "citymodel.json", text );

		},
		getMaterialThemes( citymodel ) {

			if ( ! citymodel || ! citymodel.CityObjects ) {

				return [];

			}

			const themes = Object.entries( citymodel.CityObjects ).map( cityobject => {

				const [ , obj ] = cityobject;

				if ( obj && obj.geometry && Array.isArray( obj.geometry ) ) {

					return obj.geometry.map( geom => {

						if ( geom && geom.material ) {

							return Object.keys( geom.material );

						} else {

							return [];

						}

					} );

				} else {

					return [];

				}


			} ).flat( 2 );

			return [ ... new Set( themes ) ];

		},
		getTextureThemes( citymodel ) {

			if ( ! citymodel || ! citymodel.CityObjects ) {

				return [];

			}

			const themes = Object.entries( citymodel.CityObjects ).map( cityobject => {

				const [ , obj ] = cityobject;

				if ( obj && obj.geometry && Array.isArray( obj.geometry ) ) {

					return obj.geometry.map( geom => {

						if ( geom && geom.texture ) {

							return Object.keys( geom.texture );

						} else {

							return [];

						}

					} );

				} else {

					return [];

				}


			} ).flat( 2 );

			return [ ... new Set( themes ) ];

		},
		onLoadComplete() {

			this.materialThemes = this.getMaterialThemes( this.citymodel );
			this.textureThemes = this.getTextureThemes( this.citymodel );
			this.textureManager = new TextureManager( this.citymodel );

		},
		changeCameraView(direction) {
			if (this.$refs.viewer) {
				this.$refs.viewer.setCameraView(direction);
			}
		},
		resetCamera() {
			if (this.$refs.viewer) {
				this.$refs.viewer.resetToPerspectiveCamera();
			}
		},
		toggleRotation() {
			this.isRotating = !this.isRotating;
			if (this.$refs.viewer) {
				if (this.isRotating) {
					this.$refs.viewer.startAutoRotation();
				} else {
					this.$refs.viewer.stopAutoRotation();
				}
			}
		},
		toggleFullscreen() {
			const viewer = document.getElementById('viewer');
			if (!viewer) return;

			if (!this.isFullscreen) {
				// 进入全屏
				if (viewer.requestFullscreen) {
					viewer.requestFullscreen();
				} else if (viewer.webkitRequestFullscreen) {
					viewer.webkitRequestFullscreen();
				} else if (viewer.mozRequestFullScreen) {
					viewer.mozRequestFullScreen();
				} else if (viewer.msRequestFullscreen) {
					viewer.msRequestFullscreen();
				}
			} else {
				// 退出全屏
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.webkitExitFullscreen) {
					document.webkitExitFullscreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				}
			}
		}
	},
	mounted() {
		// 监听全屏状态变化
		const handleFullscreenChange = () => {
			this.isFullscreen = !!(document.fullscreenElement ||
				document.webkitFullscreenElement ||
				document.mozFullScreenElement ||
				document.msFullscreenElement);
		};

		document.addEventListener('fullscreenchange', handleFullscreenChange);
		document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
		document.addEventListener('mozfullscreenchange', handleFullscreenChange);
		document.addEventListener('MSFullscreenChange', handleFullscreenChange);
	},
	beforeDestroy() {
		// 清理监听器
		const handleFullscreenChange = () => {
			this.isFullscreen = !!(document.fullscreenElement ||
				document.webkitFullscreenElement ||
				document.mozFullScreenElement ||
				document.msFullscreenElement);
		};

		document.removeEventListener('fullscreenchange', handleFullscreenChange);
		document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
		document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
		document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
	}
};
</script>

<style scoped>
.logo-big {
  position: absolute;
  height: 120px;
}

.logo-regular {
  height: 24px;
}

.text-big {
  font-size: 24px;
  text-align: center;
  padding-left: 0px;
  line-height: 1;
}

.logo-w {
  height: 64px; /* 可调整，例如 24px, 28px 看效果 */
  width: auto;
}

.logo-b {
  height: 24px; /* 可调整，例如 24px, 28px 看效果 */
  width: auto;
}

/* 弹窗遮罩层 */
.texture-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

/* 弹窗容器 */
.texture-modal {
  width: 100%;
  max-width: 1200px;
  max-height: 80vh;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  position: relative;
  overflow-y: auto;
}

/* 关闭按钮 */
.modal-close {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  transition: color 0.2s;
}
.modal-close:hover {
  color: #333;
}

/* 标题 */
.modal-title {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 18px;
}

/* 图片列表 */
.texture-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 15px;
}

/* 单个图片项 */
.texture-item {
  text-align: center;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
}

/* 图片样式 */
.texture-img {
  width: 100%;
  height: 120px;
  object-fit: contain;  /* 保持图片比例 */
  margin-bottom: 8px;
  background: #f5f5f5;
}

/* 图片名称 */
.texture-name {
  font-size: 14px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}

/* 无图片提示 */
.no-texture {
  text-align: center;
  padding: 50px 0;
  color: #999;
  font-size: 16px;
}

/* 全屏模式下的控件样式 */
#viewer:fullscreen .col-auto,
#viewer:-webkit-full-screen .col-auto,
#viewer:-moz-full-screen .col-auto {
  z-index: 9999 !important;
}

/* 下拉菜单样式优化 */
.dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
}

.dropdown-item {
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}
</style>
